export default __webpack_public_path__ + "static/base-package-tv-lg-7dffe833306423d721d3484c0826d8b5.png";